import React from 'react';
import { twMerge } from '@/utilities';

type DividerProps = React.PropsWithChildren<{
  className?: string;
}>;

export const Divider = React.memo<DividerProps>(props => {
  const { className, children, ...rest } = props;
  return (
    <div
      className={twMerge('border-t border-borderLight relative', className)}
      {...rest}
    >
      {children && (
        <div className="text-textLight absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white h-8">
          {children}
        </div>
      )}
    </div>
  );
});
